var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysicalMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 89.051 79.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16852",
    "data-name": "Group 16852",
    transform: "translate(-144 -4249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32467",
    "data-name": "Path 32467",
    d: "M33.276,2A18.276,18.276,0,1,0,51.551,20.276,18.276,18.276,0,0,0,33.276,2Z",
    transform: "translate(129 4247)",
    fill: "#cdf7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32517",
    "data-name": "Path 32517",
    d: "M87.761,15.705H25.73a7.514,7.514,0,0,0-7.523,7.485V69.88a7.514,7.514,0,0,0,7.523,7.485H41.546a8.182,8.182,0,0,1-2.636,4.924H36.1a1.534,1.534,0,1,0,0,3.068H77.371a1.534,1.534,0,1,0,0-3.068H74.565a8.351,8.351,0,0,1-2.636-4.924H87.745a7.514,7.514,0,0,0,7.523-7.485V23.19A7.491,7.491,0,0,0,87.761,15.705ZM25.73,18.773H87.745a4.43,4.43,0,0,1,4.44,4.417V65.539H21.29V23.19A4.43,4.43,0,0,1,25.73,18.773ZM70.542,82.3H42.949a12.335,12.335,0,0,0,1.727-4.924h24.14A12.335,12.335,0,0,0,70.542,82.3Zm17.219-7.991H25.73a4.443,4.443,0,0,1-4.44-4.433V68.607H92.2V69.88A4.443,4.443,0,0,1,87.761,74.313Z",
    transform: "translate(137.283 4242.446)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32518",
    "data-name": "Path 32518",
    d: "M31.881,43.654h11.3a1.582,1.582,0,0,0,1.376-.816l5.55-10.412,8.425,25.417a1.538,1.538,0,0,0,1.438,1.043H60a1.547,1.547,0,0,0,1.453-1l8.471-22.622,2.8,7.4a1.556,1.556,0,0,0,1.453.982h9.445a1.512,1.512,0,1,0,0-3.022H75.242l-3.9-10.261a1.562,1.562,0,0,0-2.906.015L60.077,52.751,51.9,28.074a1.564,1.564,0,0,0-2.844-.242l-6.817,12.8H31.881a1.512,1.512,0,1,0,0,3.022Z",
    transform: "translate(136.271 4241.501)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalMonitoring);
export default __webpack_public_path__ + "static/media/PhysicalMonitoring.39f15ca552fdfc1719a3f1378b7891e5.svg";
export { ForwardRef as ReactComponent };